<template>
  <article>
    <custom-callout
      v-for="currentStudent in studentList"
      :key="currentStudent.id"
      :has-toggle="false"
      class="mt-2 mb-3"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 col-md-3 mb-2 mb-md-0">
            <span class="box-result-field-label">Nombre del Estudiante:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.sie }} - {{ currentStudent.name }}
            </span>
          </div>
          <div class="col-6 col-md-1 mb-1 mb-md-0">
            <span class="box-result-field-label">Edad:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.age }}
            </span>
          </div>
          <div class="col-6 col-md-1 mb-1 mb-md-0">
            <span class="box-result-field-label">Grado:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.gade }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 mb-md-0">
            <span class="box-result-field-label">Impedimento:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.impediment }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 mb-md-0">
            <span class="box-result-field-label">
              Número de Solicitud
            </span>
            <br />
            <span class="box-result-field-value">
              {{
                currentStudent.requestNumber
                  ? currentStudent.requestNumber
                  : "-"
              }}
            </span>
          </div>
          <div class="col-6 col-md-2 mb-3 mb-md-0">
            <span class="box-result-field-label">
              Necesidad(es)
            </span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.necesities | empty }}
            </span>
          </div>
        </div>
      </div>
    </custom-callout>
  </article>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import alert from "@/mixin/alert.mixin";

export default {
  name: "AssignedStudentRow",
  mixins: [alert],
  components: {
    CustomCallout,
    ActionButton
  },
  props: {
    studentList: {
      type: Array,
      require: true,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
};
</script>

<style scoped>
::v-deep .border--left {
  border-left-style: none !important;
}

.box-result-field-value {
  font-weight: bold;
}
</style>
